import React, { useMemo } from "react";

import { Car } from "../../../../../../services";
import { CellContentRoot } from "../../../../../LightTable";

const BodyTypeCellContent: React.FC<BodyTypeCellContent.Props> = ({ item }) => {
	const content = useMemo(
		() => item.bodyType?.name ?? "",
		[item.bodyType?.name],
	);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace BodyTypeCellContent {
	interface Props {
		item: Car.Model;
	}
}

export default BodyTypeCellContent;
